module.exports = __webpack_public_path__ + "img/logo-dorinka.715e4f10.png";